export default "__VITE_ASSET__B4H7oNyH__"